import axios from 'axios';

export const clientSupplierApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/client-supplier`,
    headers: {
        'Content-Type': 'application/json'
    }
})